import { ActionContext } from 'vuex';
import $rq from '@/api/api';
import type { RootState } from '@/interfaces/store';
import { NetworkOrComponentState } from '@/interfaces/common';

const defaultState = (): NetworkOrComponentState => ({});

const mutations = {
    setNetworkState(state: NetworkOrComponentState, network: NetworkOrComponentState) {
        Object.assign(state, network);
    },
    resetNetworkState(state: NetworkOrComponentState) {
        Object.keys(state).forEach((key) => {
            delete state[key];
        });
    },
};

const actions = {
    async getNetworkInfo(
        { commit, dispatch }: ActionContext<NetworkOrComponentState, RootState>,
        networkId: string,
    ) {
        try {
            const { data } = await $rq.getNetworkInfo(networkId);
            commit('setNetworkState', data as NetworkOrComponentState);
        } catch (err) {
            dispatch('resetNetworkInfo');
        }
    },
    resetNetworkInfo({ commit }: ActionContext<NetworkOrComponentState, RootState>) {
        commit('resetNetworkState');
    },
};

const getters = {
    network: (state: NetworkOrComponentState): NetworkOrComponentState => state,
};

const state: NetworkOrComponentState = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
